<template>
  <div class="w-container">
    <div class="empty" v-if="showEmpty">暂无数据</div>
    <div v-else>
      <div class="power-curve">
        <span>选定安装角的Cp-λ曲线</span>
        <el-button type="text" size="mini" @click="showCpEcharts">
          <img style="width: 25px;height: 25px;" :src="btnUrl" />
        </el-button>
      </div>
      <div class="table-operation">
        <el-table
          v-if="tableData.length > 0 && angleHeader.length > 0"
          :data="tableData"
          border
          :height="tableHeight"
          style="width: 100%"
          v-loading="cptableLoading"
          size="mini"
        >
          <el-table-column fixed width="100" prop="ratio" label="叶尖速比入">
            <el-table-column prop="ratio" width="100">
              <template slot="header" slot-scope="scope">
                <el-checkbox
                  class="checkbox-text"
                  @change="handleCheckAllChange"
                  v-model="checkedAll"
                  :indeterminate="isIndeterminate"
                  :key="scope.$index"
                  >全选</el-checkbox
                >
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="叶片安装角（β）" style="text-align: center">
            <el-table-column v-for="(item, index) in angleHeader" :key="index">
              <template slot="header" slot-scope="scope">
                <el-checkbox
                  :label="item"
                  @change="checkBoxChange"
                  v-model="checkList"
                  class="checkbox-text"
                  >{{ angleHeader[scope.$index - 1] }}</el-checkbox
                >
              </template>
              <template slot-scope="scope">
                <span>{{ scope.row.items[item].value }}</span>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog
        v-drag:common
        title="cp-λ曲线"
        :visible.sync="cpDialog.visible"
        width="80%"
        @close="cpDialog.visible = false"
      >
        <div
          v-loading="cptableLoading"
          element-loading-text="加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          class="res-chart"
        >
          <echart
            :option="cpOptions"
            :notMerge="true"
            :divStyle="{ height: '400px', width: '99%' }"
          ></echart>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// import echarts from 'echarts';
import { mapState } from 'vuex';

export default {
  props: {},
  data() {
    return {
      cptableLoading: false,
      tableData: [],
      angleHeader: [],
      checkedAll: false,
      checkList: [],
      isIndeterminate: false,
      cpDialog: {
        visible: false
      },
      cpEchartsData: {},
      idList: [],
      tableHeight: 0,
      fullHeight: document.documentElement.clientHeight,
      showEmpty: false,
      cpOptions: null,
      btnUrl: require('@/asset/public-database/power-curve.png')
    };
  },
  computed: {
    ...mapState('model', [
      'checkedList',
      'modelList',
      'currentModel',
      'menuRightType'
    ])
  },
  watch: {
    checkList(value) {
      if (value.length === 0) {
        this.isIndeterminate = false;
        return;
      }
      let checkedCount = value.length;
      this.checkedAll = checkedCount === this.angleHeader.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.angleHeader.length;
    },
    checkedList(val) {
      this.idList = val;
    },
    // 当前选中的机型
    currentModel(val) {
      this.idList = [val.turbineTypeId];
      this.checkList = [];
      this.isIndeterminate = false;
      this.checkedAll = false;
      this.fetchCpCurve();
    },
    fullHeight() {
      if (this.tableData.length > 0) {
        this.calcBoxHeight();
      }
    }
  },
  methods: {
    // 获取cp-λ曲线
    async fetchCpCurve() {
      this.tableData = [];
      this.angleHeader = [];
      this.cptableLoading = true;
      this.showEmpty = false;
      await this.$fetch('/windfarm/turbineType/getCpCurve', {
        params: {
          turbineTypeId: this.idList[0]
        }
      }).then(res => {
        if (res.code === 0) {
          if (!res.data.tableData || !res.data.angleHeader) {
            this.cptableLoading = false;
            this.tableData = [];
            this.angleHeader = [];
            this.showEmpty = true;
            return;
          }
          this.$nextTick(() => {
            this.tableData = res.data.tableData.map(item => {
              let group = {};
              item.items.forEach(value => {
                let keyStr = value.angle.toString();
                group[keyStr] = {
                  value: value.value
                };
              });
              item.items = group;
              return item;
            });
            this.angleHeader = res.data.angleHeader;
          });
          this.calcBoxHeight();
          this.cptableLoading = false;
        } else {
          this.cptableLoading = false;
        }
      });
    },
    checkBoxChange(val) {
      if (typeof val === 'boolean') {
        return;
      }
      if (this.checkList.includes(val)) {
        this.checkList.splice(this.checkList.indexOf(val), 1);
      } else {
        this.checkList.push(val);
      }
    },
    handleCheckAllChange(val) {
      this.checkList = val ? this.angleHeader : [];
      this.isIndeterminate = false;
    },
    showCpEcharts() {
      if (this.checkList.length <= 0) {
        this.$message({
          message: '请选择叶片安装角',
          type: 'error'
        });
        return;
      }
      this.cpDialog.visible = true;
      this.cpEchartsData = this.filterCpData();
      this.$nextTick(() => {
        this.cpCureInit(this.cpEchartsData);
      });
    },
    cpCureInit(data) {
      this.cpOptions = {
        dataset: {
          // 提供一份数据。
          dimensions: data.dimensions,
          source: data.cpCureData
        },
        xAxis: {
          name: '叶尖速比（λ）',
          type: 'category',
          boundaryGap: false,
          axisLine: {
            interval: 'auto',
            lineStyle: {
              type: 'solid',
              color: '#fff'
            }
          },
          splitLine: {
            interval: 'auto',
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        tooltip: {
          trigger: 'axis',
          position: function(point, params, dom) {
            let height = dom.clientHeight;
            return [point[0], -height / 2 + 100];
          },
          formatter: function(params) {
            let res = '<span>' + params[0]['name'] + '</span>';
            for (var i = 0; i < params.length; i++) {
              res +=
                '<div>' +
                params[i].seriesName +
                '°:' +
                params[i].value[params[i].seriesName] +
                '</div>';
            }
            return res;
          }
        },
        backgroundColor: 'transparent',
        legend: {
          textStyle: {
            color: '#fff'
          },
          padding: 5,
          orient: 'vertical',
          y: 'center',
          x: 'right',
          align: 'left',
          height: '80%',
          top: '6%',
          right: '16%',
          formatter: function(name) {
            return name + '°';
          }
        },
        grid: {
          left: '3%',
          right: '20%',
          bottom: '3%',
          containLabel: true
        },
        yAxis: {
          name: 'cp值',
          axisLine: {
            lineStyle: {
              type: 'solid',
              color: '#fff'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        series: data.type
      };
    },
    filterCpData() {
      let dataObj = { dimensions: null, cpCureData: null };
      let dimensions = ['ratio'];
      let type = [];
      this.checkList.forEach(val => {
        let typeObj = { type: 'line' };
        type.push(typeObj);
        dimensions.push(val);
      });
      let cpCureData = [];
      this.tableData.forEach(item => {
        let obj = {};
        obj.ratio = item.ratio;
        this.checkList.forEach(val => {
          obj[val] = item.items[val].value;
        });
        cpCureData.push(obj);
      });
      dataObj.dimensions = dimensions;
      dataObj.cpCureData = cpCureData;
      dataObj.type = type;
      return dataObj;
    },
    calcBoxHeight() {
      let viewPortHeight = document.documentElement.clientHeight;
      let documentTop = document.documentElement.clientTop;
      this.tableHeight = viewPortHeight - 145 - documentTop;
    },
    getBodyHeight() {
      this.fullHeight = document.documentElement.clientHeight;
    }
  },
  mounted() {
    this.idList = [this.currentModel.turbineTypeId];
    this.fetchCpCurve();
    window.addEventListener('resize', this.getBodyHeight);
  },
  destroyed() {
    window.removeEventListener('resize', this.getBodyHeight);
  }
};
</script>

<style lang="less" scoped>
.w-container {
  padding-top: 26px;
  box-sizing: border-box;
  width: 100%;
  .table-operation {
    display: flex;
  }
  .power-curve {
    //position: relative;
    //top: 20px;
    width: 100%;
    //z-index: 1000;
    background-color: #0477a1;
    //padding-left: 20px;
    color: #fff;
    margin: 0 auto;
    span {
      padding-left: 20px;
      font-size: 13px;
    }
    .el-button--mini {
      padding: 3px;
    }
  }
  .empty {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(50%);
    font-size: 14px;
    color: #8f9197;
    text-align: center;
  }
  /deep/.el-dialog {
    .el-dialog__body {
      background-color: rgba(40, 40, 40, 0.8);
    }
  }
}
.res-chart {
  height: 400px;
  padding-bottom: 20px;
  width: 99%;
  margin: 15px auto 20px;
}
.e-container {
  width: 100%;
  height: 100%;
}
/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: orange;
}
.checkbox-text {
  color: #fff;
}
</style>
<style lang="less" scoped>
/deep/.el-table thead.is-group th {
  background-color: #0477a1;
  color: #fff;
}
/deep/.el-table th {
  background-color: #0477a1;
  color: #fff;
}
/deep/.el-table tr:nth-of-type(odd) {
  background-color: #1e608f;
  color: #fff;
}
/deep/ .el-table tr:nth-of-type(even) {
  background-color: #126e6d;
  color: #fff;
}
/deep/.el-table__body tr:hover > td {
  background-color: #0477a1;
}
/deep/.el-table__body tr.hover-row > td {
  background-color: #0477a1;
}
</style>
